import React from "react";
import DashIcon from "./DashIcon";

/**
 * KpiCard – single metric card for the top summary row.
 * Props: { id, title, value, comparison, trend, iconType, iconBg, iconColor }
 */
const KpiCard = ({ title, value, comparison, trend, iconType, iconBg, iconColor, loading }) => {
  const trendIsUp = trend === "up";
  const trendColor = trendIsUp ? "#16A34A" : trend === "down" ? "#DC2626" : null;

  return (
    <div className="ops-kpi-card">
      <div className="ops-kpi-top">
        <div className="ops-kpi-icon-wrap" style={{ background: iconBg }}>
          <DashIcon type={iconType} size={20} color={iconColor} />
        </div>
        <span className="ops-kpi-title">{title}</span>
      </div>
      <div className="ops-kpi-value">
        {loading && (value === undefined || value === null) ? (
          <span className="spinner-border spinner-border-sm text-primary" role="status" />
        ) : (
          value
        )}
      </div>
      <div className="ops-kpi-footer">
        {trend && (
          <span style={{ color: trendColor, marginRight: 4, fontSize: 13, fontWeight: 600 }}>
            {trendIsUp ? "↑" : "↓"}
          </span>
        )}
        <span
          className="ops-kpi-comparison"
          style={{
            color: trend ? trendColor : "#7C3AED",
            fontWeight: trend ? 500 : 600,
          }}
        >
          {comparison}
        </span>
      </div>
    </div>
  );
};

export default KpiCard;
